import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { DateField, Button } from '@unite-us/ui';
import today from '../../utils/today';
import { Field, Form } from 'react-final-form';
import { get, first, isEmpty } from 'lodash';
import { callbacks, getAdapter, trackEvent } from '../../../config/api';
import { isRequired, validateDate } from '../../utils/validations';
import callOrLog from '../../../constants/callOrLog';
import { FACESHEET } from '../../../constants/eventConstants';
import moment from 'moment';
var MIN_DATE = moment("01/01/1900", "MM/DD/YYYY").utc();
function DateOfBirthForm(props) {
  var contact = props.contact;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    formErrors = _useState2[0],
    setFormErrors = _useState2[1];
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      var contact, contactId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            contact = props.contact;
            contactId = get(contact, 'id');
            _context.next = 4;
            return getAdapter('coreApi').updateRecord("person", contactId, {
              date_of_birth: value.date_of_birth
            });
          case 4:
            callOrLog(function () {
              return trackEvent(FACESHEET.dobUpdated);
            });
            props.closeModal();
            callbacks.onClientSaved();
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var formValidator = {
    dobValidator: function dobValidator(value) {
      var handleError = function handleError(error) {
        if (isEmpty(formErrors)) {
          setFormErrors(error);
        }
        return error;
      };
      if (value && isNaN(value)) {
        return handleError('Required');
      }
      var isReq = isRequired(value);
      if (isReq) {
        return handleError(isReq);
      }
      var date = moment.unix(value).utc();
      var invalidDate = validateDate(date, today(), MIN_DATE);
      if (invalidDate) {
        return handleError(invalidDate);
      }
      return '';
    }
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    initialValues: contact,
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit,
        submitting = _ref2.submitting;
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit,
        onKeyDown: function onKeyDown(e) {
          return e.key === "Enter" && e.preventDefault();
        },
        className: "content-with-actions"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "date_of_birth",
        validate: formValidator.dobValidator
      }, function (params) {
        return /*#__PURE__*/React.createElement(DateField, _extends({
          id: "date_of_birth",
          label: "Date of Birth",
          inline: false,
          style: {
            container: {
              minHeight: '250px'
            }
          },
          minDate: MIN_DATE,
          maxDate: today(),
          required: true
        }, params));
      })), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-dob-cancel-btn",
        onClick: props.closeModal,
        disabled: submitting,
        label: "Cancel"
      })), /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-dob-save-btn",
        disabled: submitting,
        label: "Save",
        primary: true,
        onClick: function onClick() {
          if (!isEmpty(formErrors)) {
            setTimeout(function () {
              var _focusableErr;
              var focusableErr;
              var err = first(document.getElementsByClassName('ui-form-field--has-error'));
              if (err) {
                focusableErr = first(err === null || err === void 0 ? void 0 : err.getElementsByTagName('input'));
              }
              if (focusableErr) {
                focusableErr.ariaLabel = formErrors;
              }
              (_focusableErr = focusableErr) === null || _focusableErr === void 0 || _focusableErr.focus();
              setFormErrors({});
            }, 300);
          } else if (first(document.getElementsByClassName('ui-form-field--has-error'))) {
            var editDOBModal = document.getElementById('edit-dob-modal');
            var errInModal = first(editDOBModal === null || editDOBModal === void 0 ? void 0 : editDOBModal.getElementsByClassName('ui-form-field--has-error'));
            var focusableErr = first(errInModal === null || errInModal === void 0 ? void 0 : errInModal.getElementsByTagName('input'));
            focusableErr === null || focusableErr === void 0 || focusableErr.focus();
          }
          handleSubmit();
        }
      }))));
    }
  });
}
DateOfBirthForm.propTypes = {
  closeModal: PropTypes.func,
  contact: PropTypes.object.isRequired
};
export default DateOfBirthForm;
//# sourceMappingURL=DateOfBirthForm.js.map